import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import YupPassword from 'yup-password'
import './../EditProfile.css'
import clsx from 'clsx';
import { emailRegex, phone_regex } from '../../../../shared/const';
import { AppGeneralContext } from '../../../../shared/GeneralContext/GeneralContext';
import { UserInfo, initialuserInfo, Department, Role, StartUp, Corporate, OptionTypes, ModalType, initialStateModal } from '../../../types/types';
import { Button, TitlePage } from '../../../atoms';
import Footer from '../../../organism/Footer/Footer';
import Select, { MultiValue } from 'react-select';
import mockOptions from '../../../../jsonMock/mockOptions.json'
import { customStyles } from '../../../../shared/style';
import { InputActionMeta } from 'react-select';
import { EditUserCompanyReq } from '../../../types/Api';
import { deleteTag, getReasonsList, getSectorsList, postAddTag, postCitiesList, putEditUserCompany } from '../../../../api/Api';
import { useNavigate } from 'react-router-dom';
import SelectComponent from 'components/atoms/Select/SelectComponent';
import MultiSelectComponent from 'components/atoms/Select/MultiSelectComponent';
import { useAuth } from 'shared/auth';
import { OptionReasons } from 'components/types';

YupPassword(Yup)

const userInfoSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(3, 'Too Short!, min 3 char')
        .max(70, 'Too Long!, max 70 char')
        .required('Please complete this required field.'),
    lastName: Yup.string()
        .min(3, 'Too Short!, min 3 char')
        .max(70, 'Too Long!, max 70 char')
        .required('Please complete this required field.'),
    email: Yup.string()
        .matches(emailRegex, 'Wrong email format')
        .required('Please complete this required field.'),
    phoneNumber: Yup.string()
        .matches(phone_regex, 'Phone number not correct')
        .required('Please complete this required field.'),
    password: Yup.string().password()
        .nullable()
        .min(8, 'Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special')
        .minLowercase(1, 'Password must contain at least 1 lower case letter')
        .minUppercase(1, 'Password must contain at least 1 upper case letter')
        .minNumbers(1, 'Password must contain at least 1 number')
        .minSymbols(1, 'Password must contain at least 1 special character'),
    confirmPassword: Yup.string().when("password", {
        is: (password: string) => password && password.length > 0,
        then: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords don\'t match')
            .required('Please complete this required field.'),
    }),
    sectors: Yup.array()
        .min(1, 'Please select at least one field')
        .required('Please complete this required field.'),
    reasons: Yup.array()
        .required('Please complete this required field.')
        .min(1, "Please select at least one field")
        .of(
            Yup.object().shape({
                value: Yup.string(),
            })),
    reasonsHasDescription: Yup.boolean(),
    reasonsDescription: Yup.string().when("reasonsHasDescription", {
        is: (reasonsHasDescription: boolean) => reasonsHasDescription === true,
        then: Yup.string()
            .min(3, 'Too Short!, min 3 char')
            .max(250, 'Too Long!, max 250 char')
            .required('Please complete this required field.'),
        otherwise: Yup.string().notRequired()
    }),
    companyName: Yup.string()
        .min(3, 'Too Short!, min 3 char')
        .max(100, 'Too Long!, max 100 char')
        .required('Please complete this required field.'),
    jobTitle: Yup.string()
        .nullable()
        .min(3, 'Too Short!, min 3 char')
        .max(100, 'Too Long!, max 100 char')
        .required('Please complete this required field.'),
    level: Yup.object().shape({
        name: Yup.string(),
    }),
    department: Yup.object().shape({
        name: Yup.string(),
    }),
});


interface EditCorporeteProps extends UserInfo {
    companyName?: string,
    department?: OptionTypes,
    role?: StartUp | Corporate,
    jobTitle?: string
    level?: OptionTypes
    city?: OptionTypes
    sectors: OptionTypes[],
    reasons: OptionTypes[],
    reasonsHasDescription: boolean,
    reasonsDescription: string,
    tags?: OptionTypes[]
}


export const EditCorporateProfile = () => {

    const navigate = useNavigate();
    const { user, setchangePWisOpen,setresetEmailisOPen } = useContext(AppGeneralContext)
    const description = takeDescription(user?.role?.reasons)
    const ctx = useContext(AppGeneralContext)
    const initialEditCorporate: EditCorporeteProps = {
        ...user,
        firstName: user?.firstName ?? "",
        lastName: user?.lastName ?? "",
        email: user?.email ?? "",
        phoneNumber: user?.phoneNumber ?? "",
        password: "",
        confirmPassword: "",
        companyName: user?.role?.name ?? "",
        department: user?.department,
        level: user?.level,
        jobTitle: user?.jobTitle ?? "",
        city: user?.role?.city,
        sectors: user?.role?.sectors ? fromArrToOptionType(user?.role?.sectors) : [],
        reasons: user?.role?.reasons ? fromReasonsToOptionType(user?.role?.reasons) : [],
        reasonsHasDescription: user?.role?.reasons ? user.role.reasons.some( x=> x.hasDescription === true) : false,
        reasonsDescription: description ?? "",
        tags: user?.role?.tags ?? undefined
    }
    const [cities, setCities] = useState<OptionTypes[]>()
    const [city, setCity] = useState<string>("")
    const [sectorsSelected, setSectorsSelected] = useState<MultiValue<OptionTypes>>(initialEditCorporate.sectors)
    const [sectors, setSectors] = useState<OptionTypes[]>([])
    const [reasonSelected, setReasonsSelected] = useState<MultiValue<OptionTypes>>(initialEditCorporate.reasons)
    const [reasons, setReasons] = useState<OptionTypes[]>([])
    const [loadingMessage, setLoadingMessage] = useState<string | undefined>(undefined)

    const tagSchema = Yup.object().shape({
        tag: Yup.string()
            .max(20, 'Too Long!, max 20 char')

    });
    
   
    function takeDescription(arr: OptionReasons[] | undefined) {
        if(!arr){
            return ""
        }

        let description = arr.filter( x=>{
           if(x.hasDescription && x.description){
            return x.description
           }
           return
        })
    
        
        if (description.length !== 0) {
            return description[0].description 
        } else {
            return ""
        }

    }
    
    function fromArrToOptionType(arr: Array<OptionTypes>) {
        if(!arr){
            return []
        }

        return arr.map(element => {
            return {
                value: element.id ?? element.value.toString(),
                label: element.description ?? element.label
            }
        })
    }
     function fromReasonsToOptionType(arr: Array<OptionReasons>) {

        if(!arr){
            return []
        }
    
        let newArr:OptionTypes[] =  arr.map((element) => {
            return {
                value: element.value.toString(),
                label: element.label,
            }
        })

        return newArr
    }



    useEffect(() => {
        ctx.getDepartmentsOptionsList()
        ctx.getLevelOptionsList()
    }, [])


    useEffect(() => {
        getSectorsList().then((res) => {
            let resp = res.response
            if (res.isSuccess && resp) {
                setSectors(resp.sectors ?? [])
            }
        })



        getReasonsList().then((res) => {
            let resp = res.response
            if (res.isSuccess && resp) {
                let reasonsOptionType = resp?.reasons.map(x => {
                    return { value: x.value, label: x.label }
                })
                setReasons(reasonsOptionType ?? [])
            }
        })
    }, [])



    const formikTag = useFormik({
        initialValues: { tag: "" },
        validationSchema: tagSchema,
        onSubmit: async (values, { setSubmitting }) => {
            if (user?.tags?.some(x => x.label === values.tag)) {
                  formikTag.setFieldError("tag", "Existing tag")
                return
            }

            setSubmitting(true)
            ctx.setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })


            const data = values.tag
            postAddTag({ data }).then((res) => {

                if (!res.isSuccess || !res.response) {
                    ctx.setErrorModal(res.error)
                    return false
                }

                formikTag.setFieldValue("tag", "")


                if (ctx.loginType) {
                    ctx.getUserData(ctx.loginType).then(() => {
                        // setIsEditView(false)
                        setTimeout(() => ctx.setClosedModal(), 1000)
                    })

                }
            })
        }
    })



    const removeTag = (tagId: string) => {
        ctx.setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })

        deleteTag(tagId).then((res) => {
            if (!res.isSuccess || !res.response) {
                ctx.setErrorModal(res.error)
                return false
            }

            if (ctx.loginType) {
                ctx.getUserData(ctx.loginType).then(() => {
                    // setIsEditView(false)
                })
            }
            ctx.setClosedModal()
        })
    }



    const onChange = (option: MultiValue<OptionTypes>) => {
        if (option) {
            setSectorsSelected(option)
            formik.setFieldValue("sectors", option)
        }
    }

    

    const onChangeReasons = (option: MultiValue<OptionTypes>) => {
        if (option) {
            setReasonsSelected(option)
            formik.setFieldValue("reasons", option)
        }

        if (option.some(x => x.label.includes("Other"))) {
            formik.setFieldValue("reasonsHasDescription", true)
        } else {
            formik.setFieldValue("reasonsHasDescription", false)
        }
    }

    useEffect(() => {
        postCitiesList({ data: city }).then((res) => {
    
          if (!res.isSuccess || !res.response) {
            ctx.setErrorModal(res.error)
            return false
          }
    
          const response = res.response.data
          setCities(response)
        })
    
    
      }, [])

    useEffect(() => {
        if (city.length >= 3) {
            postCitiesList({ data: city }).then((res) => {

                if (!res.isSuccess || !res.response) {
                    ctx.setErrorModal(res.error)
                    return false
                }

                const response = res.response.data
                setCities(response)
            })
        } else {
            setCities([])
        }
    }, [city.length])

    const formik = useFormik<EditCorporeteProps>({
        initialValues: initialEditCorporate,
        validationSchema: userInfoSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)
            ctx.setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })
           
            let sectors = values.sectors ? values.sectors.map(x => x.value) : []
            let reasonsOption = values.reasons ? values.reasons.map(x => {
                if (x.label.includes("Other")) {
                    return {
                        id: x.value,
                        value: x.value,
                        label: x.label,
                        hasDescription: true,
                        description: values.reasonsDescription
                    }
                } else {
                    return {
                        id: x.value,
                        value: x.value,
                        label: x.label,
                        hasDescription: false,
                    }
                }
            }) : []

            let req: EditUserCompanyReq = {
                firstName: values.firstName,
                lastName: values.lastName,
                phoneNumber: values.phoneNumber,
                jobTitle: values.jobTitle ?? "",
                departmentId: values.department?.value ?? "",
                levelId: values.level?.value as string,
                name: values.companyName ?? "",
                cityId: values.city?.value,
                sectorsIds: sectors,
                reasons: reasonsOption
            }


            if (values.password) {
                req = { ...req, password: values.password }
            }

            putEditUserCompany(req).then(async (res) => {

                if (!res.isSuccess || !res.response) {
                    ctx.setErrorModal(res.error)
                    setSubmitting(false)
                    return
                }

                if (ctx.loginType) {
                    const reloaded = await ctx.getUserData(ctx.loginType)
                    if (reloaded) {
                        ctx.setClosedModal()
                    }
                }

                navigate('/corporate/profile')

            })
            setSubmitting(false)
        }
    })



    useEffect(()=>{
        formik.setFieldValue("reasons", reasonSelected)
        if (reasonSelected.some(x => x.label.includes("Other"))) {
            formik.setFieldValue("reasonsHasDescription", true)   
        } else {
            formik.setFieldValue("reasonsHasDescription", false)
            formik.setFieldValue("reasonsDescription", "")
        }
    },[reasonSelected, formik.values.reasonsDescription])


    return (


        <div className="row p-0 m-0 pt-4 ">
            <div className='w-100'>
                <div className='d-flex justify-content-between'>
                    <TitlePage as='h3' title={'edit profile'} />
                    <div className='d-flex'>
                        <span  className=' text-danger' style={{ fontSize: "16px" }}>*</span>
                        <span  className=' text-danger pe-md-4'>required</span>
                    </div>
                </div>

                <form  onSubmit={formik.handleSubmit} className='' autoComplete='off'>

                    <div className='d-flex flex-wrap'>
                        {/* firstName*/}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="firstName">First Name <sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <input
                                autoComplete="new-password"
                                placeholder='First Name'
                                {...formik.getFieldProps('firstName')}
                                className="form-input "
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={() => formik.setFieldTouched("firstName", true)}
                                value={formik.values.firstName}
                                name="firstName"
                            />
                            {formik.errors.firstName && formik.touched.firstName && <div className='text-error' id="firstName">{formik.errors.firstName}</div>}
                        </div>

                        {/* lastName */}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="lastName">Last Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <input
                                autoComplete="new-password"
                                placeholder='Last Name'
                                {...formik.getFieldProps('lastName')}
                                className="form-input"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={() => formik.setFieldTouched("lastName", true)}
                                value={formik.values.lastName}
                                name="lastName"
                            />
                            {formik.errors.lastName && formik.touched.lastName && <div className='text-error' id="lastName">{formik.errors.lastName}</div>}
                        </div>

                        {/* email */}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className=' disabled text-black mt-3' htmlFor="email">Email<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <input
                                autoComplete="new-password"
                                disabled
                                placeholder='Your Email'
                                {...formik.getFieldProps('email')}
                                className="form-input disabled"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={() => formik.setFieldTouched("email", true)}
                                value={formik.values.email}
                                name="email"
                            />
                            {formik.errors.email && formik.touched.email && <div className='text-error' id="email">{formik.errors.email}</div>}
                        </div>

                        {/* phoneNumber */}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="phoneNumber">Mobile Phone Number<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <input
                                autoComplete="new-password"
                                placeholder='Your mobile phone number'
                                {...formik.getFieldProps('phoneNumber')}
                                className="form-input"
                                type="tel"
                                onChange={formik.handleChange}
                                onBlur={() => formik.setFieldTouched("phoneNumber", true)}
                                value={formik.values.phoneNumber}
                                name="phoneNumber"
                            />
                            {formik.errors.phoneNumber && formik.touched.phoneNumber && <div className='text-error' id="phoneNumber">{formik.errors.phoneNumber}</div>}
                        </div>
                        {/* CompanyName*/}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="companyName">Company Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <input
                                autoComplete="new-password"
                                placeholder='Company Name'
                                {...formik.getFieldProps('companyName')}
                                className="form-input "
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={() => formik.setFieldTouched("companyName", true)}
                                value={formik.values.companyName}
                                name="companyName"
                            />
                            {formik.errors.companyName && formik.touched.companyName && <div className='text-error' id="companyName">{formik.errors.companyName}</div>}
                        </div>

                        {/* Department*/}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="department">Department<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <Select
                                isLoading={ctx.loadingDepartmentOptions}
                                className='w-100 '
                                {...formik.getFieldProps('department')}
                                onChange={option => { formik.setFieldValue('department', option); }}
                                onBlur={() => formik.setFieldTouched("department", true)}
                                options={ctx.departmentOptions}
                                captureMenuScroll={true}
                                placeholder='Select your department'
                                styles={customStyles}
                                value={!!formik.values.department ? formik.values.department : null}
                                components={{ IndicatorSeparator: () => null }} />
                            {formik.errors.department && formik.touched.department && <div className='text-error' id="department">{formik.errors.department}</div>}
                        </div>

                        {/* JobTitle*/}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="jobTitle">Job Title<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <input
                                autoComplete="new-password"
                                placeholder='Job Title'
                                {...formik.getFieldProps('jobTitle')}
                                className="form-input "
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={() => formik.setFieldTouched("jobTitle", true)}
                                value={formik.values.jobTitle}
                                name="jobTitle"
                            />
                            {formik.errors.jobTitle && formik.touched.jobTitle && <div className='text-error' id="jobTitle">{formik.errors.jobTitle}</div>}
                        </div>
                        {/* Levels*/}
                        <div className='col-lg-6 col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="role">Level<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <Select
                                isLoading={ctx.loadingLevelsOptions}
                                className='w-100 '
                                {...formik.getFieldProps('level')}
                                onChange={option => { formik.setFieldValue('level', option); }}
                                onBlur={() => formik.setFieldTouched("level", true)}
                                options={ctx.levelsOptions}
                                captureMenuScroll={true}
                                placeholder='Select your level'
                                styles={customStyles}
                                value={!!formik.values.level ? formik.values.level : null}
                                components={{ IndicatorSeparator: () => null }}
                            />
                            {formik.errors.level && formik.touched.level && <div className='text-error' id="level">{formik.errors.level}</div>}
                        </div>
                        {/* city*/}
                        <div className='col-12 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="city">City<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <SelectComponent
                                borderColor='1px solid #cbd6e2'
                                options={cities ? cities : []}
                                fieldName={'city'}
                                setSelectSearch={setCity}
                                formik={formik}
                                isSearchable
                                className={"w-100 "}
                                value={!!formik.values.city?.value ? formik.values.city : null}
                            />
                            {formik.errors.city && formik.touched.city && <div className='text-error' id="city">{formik.errors.city}</div>}
                        </div>
                        {/* Sectors*/}
                        <div className=' col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="sectors">What technologies are you looking for? <sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <MultiSelectComponent
                                formik={formik}
                                heightControlSection="47px"
                                isSearchable
                                setOptionSelected={onChange}
                                placeholder="Please select  technologies"
                                className={"w-100 "}
                                options={sectors}
                                fieldName={'sectors'}
                                value={sectorsSelected ? sectorsSelected : null}
                                isNotFilter
                            />
                            {formik.touched?.sectors && formik.errors?.sectors && (
                                <div className='fv-plugins-message-container mt-2'>
                                    <div className='fv-help-block'>
                                       <span  className=' text-danger' role='alert'>{formik.errors?.sectors.toString()}</span> 
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* reasons */}
                        <div className=' col-12 flex-grow-1 pe-md-4'>
                            <label className='text-black mt-3' htmlFor="reasons">Why are you using Innovation Match? <sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                            <MultiSelectComponent
                                heightControlSection="47px"
                                isSearchable
                                setOptionSelected={onChangeReasons}
                                placeholder="Please select  reasons"
                                className={"w-100 "}
                                options={reasons}
                                formik={formik}
                                fieldName={'reasons'}
                                value={reasonSelected ? reasonSelected : null}
                                isNotFilter
                            />
                            {formik.touched?.reasons && formik.errors?.reasons && (
                                <div className='fv-plugins-message-container mt-2'>
                                    <div className='fv-help-block'>
                                        <span  className=' text-danger' role='alert'>{formik.errors?.reasons.toString()}</span> 
                                    </div>
                                </div>
                            )}

                            {formik.values.reasonsHasDescription &&
                                <div>
                                    {/* reasonsDescription */}
                                    <label className='text-black mt-3' htmlFor="reasonsDescription">Other <sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                                    <textarea
                                        style={{ minHeight: "100px" }}
                                        placeholder=''
                                        {...formik.getFieldProps('reasonsDescription')}
                                        className="form-input py-2 "
                                        onChange={(e) => formik.setFieldValue("reasonsDescription", e.target.value)}
                                        onBlur={() => formik.setFieldTouched("reasonsDescription", true)}
                                        value={formik.values.reasonsDescription ? formik.values.reasonsDescription : undefined}
                                        name="reasonsDescription"
                                    />
                                    {formik.errors.reasonsDescription && formik.touched.reasonsDescription && <div className='text-danger ms-2' id="reasonsDescription">{formik.errors.reasonsDescription}</div>}
                                </div>}
                        </div>
                        {/* Level*/}
                        <div className='w-100 d-flex justify-content-end my-4 pe-md-4'>
                            <Button
                                type='button'
                                onClick={() => setresetEmailisOPen(true)}
                                className='mt-1 me-3' // Add margin to the right
                                color='var(--white)'
                                background='var(--primary)'
                                borderColor='var(--primary)'
                                fontWeight={'800'}
                                uppercase primary text='Reset Email' />
                            <Button
                                type='button'
                                onClick={() => setchangePWisOpen(true)}
                                className='mt-1 me-3' // Add margin to the right
                                color='var(--white)'
                                background='var(--primary)'
                                borderColor='var(--primary)'
                                fontWeight={'800'}
                                uppercase primary text='Change Password' />
                            <Button
                                disabled={!formik.isValid}
                                type="submit"
                                className='mt-1' // No margin needed
                                color='var(--white)'
                                background='var(--primary)'
                                borderColor='var(--primary)'
                                fontWeight={'800'}
                                uppercase primary text='Save' />
                            </div>

                    </div>
                </form >
                <form onSubmit={formikTag.handleSubmit} id="form2" autoComplete='off' className='flex-grow-1 pe-md-4 mb-4'>
                    <div className={"w-100 m-0 p-0 "}>
                        <div className={" m-0 p-0 flex-row d-flex w-100  flex-wrap "}>
                            <div className={"w-100 m-0 p-0"} >
                            <label className='text-black mt-3' htmlFor="tags">Tags: Attention! The maximum number of tags you can add is 10</label>

                                <div className='d-flex mt-2'>
                                    <input
                                        autoComplete="new-password"
                                        style={{ borderRight: "none" }}
                                        placeholder='Add tag'
                                        {...formikTag.getFieldProps('tag')}
                                        className="form-input  w-100"
                                        type="text"
                                        onChange={formikTag.handleChange}
                                        onBlur={() => { formikTag.setFieldTouched("tag", true) }}
                                        value={formikTag.values.tag}
                                        name="tag"
                                    />
                                    <Button
                                        disabled={
                                            formikTag.isSubmitting ||
                                            !formikTag.isValid ||
                                            !formikTag.touched ||
                                            !formikTag.values.tag
                                        }
                                        padding="0px 20px" type="submit" form="form2" className='' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary text='add' />
                                    {formikTag.errors.tag && formikTag.touched.tag && <div id="feedback" className='text-error'>{formikTag.errors.tag}</div>}
                                </div>
                            </div>
                            <div className={"form-input mt-2"} style={{ minHeight: ("80px") }}>
                                <ul className='d-flex flex-wrap align-items-start  m-0 p-0 mt-2 tags ' style={{ listStyleType: "none" }} >
                                    {user?.role?.tags?.map((tag) => {
                                        return <li key={tag.value} className='tag'>
                                            {tag.label}
                                            <span   className='cursor-pointer ms-2'
                                                onClick={() => removeTag(tag.value as string)}>
                                                x
                                            </span>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </form >
                <Footer />
            </div>
        </div>

    )
}

